import styled from 'styled-components';
import { Body, H5 } from 'syf-component-library/ui/typography';
import { Inset } from 'syf-component-library/ui/spacing';
import { fontWeights, spacing } from 'syf-component-library/defaultTheme';
import query from 'syf-component-library/const/mediaQueries';
export const HeaderContainer = styled(Inset) `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  width: 90%;
`;
export const ImageContainer = styled(Inset) `
  display: flex;
  justify-content: center;
`;
export const Image = styled.img `
  height: auto;
  width: 100%;
  max-width: 144px;
  margin: auto;
  @media ${query.lessThanSmall} {
    max-width: 115px;
  }
`;
export const HeaderTitle = styled(H5) `
  font-weight: ${fontWeights.bold};
  margin-bottom: ${spacing.small}px;
`;
export const SubTitle = styled(Body) `
  @media ${query.lessThanMedium} {
    display: inline;
  }
`;
